import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services';
import { showToastSuccess } from 'src/utilities/toast';

export type UseUpdatePatientContactDetailsPayload = {
  patientId: number | null;
  phone?: string;
  email?: string;
};

export const useUpdatePatientContactDetails = (serviceRequestId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updatePatientContactDetails'],
    mutationFn: ({
      patientId,
      phone,
      email,
    }: UseUpdatePatientContactDetailsPayload) =>
      api
        .patch(`/v3/patients/${patientId}`, {
          phone_number: phone,
          email_address: email,
        })
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['serviceRequest', serviceRequestId],
      });
      showToastSuccess('Patient contact details updated');
    },
  });
};
